const refIds = {
  "albertpark.jayco.com.au": "testRefId", // vi testing
  "jaycoalbertpark.com.au": "testRefId", // vi testing
  "jaycohobart.com.au" : "4e3f07f",
  "bayswaterjayco.com.au": "6e5b19e",
  "jaycomildura.com.au": "398ca7f",
  "jaycoballarat.com.au": "31cd370",
  "jaycogippsland.com.au": "30a11c9",
  "pagebrosrv.com.au": "31d0aa1",
  "jaycoadelaide.com.au": "308fdd4",
  "mtgambier.jayco.com.au": "2fea4a4",
  "jaycodarwin.com.au": "307b2ae",
  "caravanland.com.au": "2fcb3eb",
  "jaycoaw.com.au": "5b2b10e",
  "jaycodubbo.com.au": "3082110",
  "jayconewcastle.com.au": "30476cf",
  "jayconowra.com.au": "4ec21c5",
  "jaycoorange.com.au": "704bd2e",
  "jaycosydney.com.au": "2ff4a37",
  "watsonsjayco.com.au": "2ffefca",
  "jaycocanberra.com.au": "391e45f",
  "jaycocairns.com.au": "3024ee5",
  "jaycotownsville.com.au": "2ff1306",
  "jaycomackay.com.au": "2fbd727",
  "jaycobundaberg.com.au": "3028616",
  "prestigejaycogeelong.com.au" : "3066788",
  "prestigejaycobendigo.com.au" : "304e531",
  "jaycocoffsharbour.com.au": "3013af0"
  // "jaycoadelaide.com.au": "308fdd4",
  // "mtgambier.jayco.com.au": "2fea4a4",
  // "kingcaravans.jayco.com.au": "30103bf",
  // "caravanland.com.au": "2fcb3eb",
  // "jaycodarwin.com.au": "307b2ae",
  // "jaycocairns.com.au": "3024ee5",
  // "jaycotownsville.com.au": "2ff1306",
  // "jaycobundaberg.com.au": "3028616",
  // "jaycoaw.com.au": "3017221",
  // "jayconewcastle.com.au": "30476cf",
  // "jayconowra.com.au": "3093505",
  // "jaycoorange.com.au": "2ffb899",
  // "jaycosydney.com.au": "2ff4a37",
  // "watsonsjayco.com.au": "2ffefca",
  // "mildura.jayco.com.au": "398ca7f",
  // "jaycoballarat.com.au": "31cd370",
  // "jaycogippsland.com.au": "30a11c9",
  // "pagebrosrv.com.au": "31d0aa1",
  // "horsham.jayco.com.au": "2fdc7e0",
  // "jaycocanberra.com.au": "391e45f"
}

export default refIds;